export default "__VITE_ASSET__DBFhvwr7__"